<template>
  <div class="first_page section_bg">
    <loading-block v-if="is_load==false" :loading="!is_load"/>
    <section class="   my-0 overflow-hidden  " v-if="is_load">



      <div class="container mobile_div">

          <div class="mobile_div section_header">
            <h5 class="text-center">Портфолио</h5>
          </div>

          <div class="mobile_div section_header d-flex justify-content-center row  mt-3 mb-3">
            <div class="col-12 col-md-6 col-lg-6"  v-for="(category,category_index) in categorys" :key="category.last_id">

              <div class="item_card_mini text-center pb-2">
                <h5 class="card-title">{{ category.name}}</h5>
                 <router-link class="btn btn-sm" style="margin-right:10px;" tag="a"
                                 :to="{name: 'works_in_category', params: {category_id:category.last_id  }}">Посмотреть работы</router-link>


              </div>
            </div>


          </div>



      </div>
    </section>
  </div>
</template>

<script>

import Api from "../../models/Api";
import Vue from "vue";
import LoadingBlock from "@/components/Custom/LoadingBlock";




var Avatar = require('vue-avatar');


export default {
  name: 'home',

  components: {LoadingBlock},
  data() {
    return {
      "is_load":false,
     "categorys":[],
      'tags':[],
      'current_portfolio_tags':"all_works_tag",
    }
  },
  mounted() {
  var app=this;
  Api.loadAboutcategorys_portfolio(function(data){

    if(data.length>0){
      app.categorys=data;
      app.is_load=true;
    }
  })
  },
  methods: {





  }
};
</script>
